<template>
    <div id='ScreenLock' class='container-fluid'>
        <div class='centerAlign'>
            <img :src=logoSrc alt='WGACA' />
            <h1>LLAMAv3</h1>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ScreenLock',
        data: function() {
            return {
                logoSrc: '/images/footer-logo.svg'
            }
        },
        mounted: function(){
            this.$api
                .get('sanctum/csrf-cookie', {}, 'none')
                .then(() => this.$store.dispatch('Auth/authenticate', this.$router.resolve({path: '/authenticate/azuread'}).href))
        }

    }
</script>